import * as _ from 'lodash';

import * as types from './types';
import { SITE_TYPE } from 'Common/Constants';
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  siteSetup: {
    Data: [],
    Errors: [],
  },
  filteredData: [],
  result: {
    errors: [],
    isSubmitting: false,
  },
  siteGroups: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SITESETUP_CLEAR_ERRORS:
      return {
        ...state,
        result: {
          ...state.result,
          errors: [],
        },
      };

    case types.SITESETUP_GET:
      return {
        ...state,
        siteSetup: {
          ...action.payload.data,
          Data: action.payload.data.Data.map(site => ({
            ...site,
            MealExpirationDT: site.MealExpirationDT
              ? defaultDateFormat(site.MealExpirationDT)
              : 'MBE Not Enabled',
          })),
        },
      };

    case types.SITESETUP_GET_SITEGROUPS:
      const siteGroups = action.payload.data.Data;
      const orderedSiteGroups = _.orderBy(siteGroups, [
        siteGroups => siteGroups.Description.toLowerCase(),
      ]);

      return { ...state, siteGroups: orderedSiteGroups };

    case types.SITESETUP_ERROR:
      return {
        ...state,
        siteSetup: { ...state.siteSetup, Errors: action.payload.data.Errors },
      };

    case types.SITESETUP_SET_FILTERED_DATA:
      const { payload: { IsLicensed, IsActive } = {} } = action;
      let filtered = [];
      if (IsLicensed && IsActive) {
        filtered = state.siteSetup.Data;
      } else if (!IsLicensed && !IsActive) {
        filtered = _.filter(state.siteSetup.Data, {
          IsActive: !IsActive,
          IsLicensed: !IsLicensed,
        });
      } else if (IsLicensed && !IsActive) {
        filtered = _.filter(state.siteSetup.Data, {
          IsActive: !IsActive,
        });
      } else if (!IsLicensed && IsActive) {
        filtered = _.filter(state.siteSetup.Data, {
          IsLicensed: !IsLicensed,
        });
      }

      filtered = _.orderBy(filtered, [x => x.Id]);

      return {
        ...state,
        filteredData: filtered,
      };

    case types.SITESETUP_MAP_COLUMNS:
      const newArray = state.siteSetup.Data.map(item => {
        const foundGroup = _.find(state.siteGroups, {
          Id: item.SiteGroupId,
        });
        item.SiteGroup = foundGroup ? foundGroup.Description : '';

        const foundType = _.find(SITE_TYPE, {
          id: item.SiteMasterTypeId,
        });

        item.SiteType = foundType ? foundType.description : '';

        return item;
      });

      return {
        ...state,
        siteSetup: { ...state.siteSetup, Data: newArray },
      };

    case types.SITESETUP_POST:
      return {
        ...state,
        result: {
          ...state.result,
          errors: action.payload.data.Errors,
        },
      };

    case types.SITESETUP_BEGIN_SUBMIT:
      return {
        ...state,
        result: {
          ...state.result,
          errors: [],
          isSubmitting: true,
        },
      };

    case types.SITESETUP_END_SUBMIT:
      return {
        ...state,
        result: {
          ...state.result,
          isSubmitting: false,
        },
      };

    case types.SITESETUP_HAD_ERROR:
      return {
        ...state,
        result: {
          ...state.result,
          errors: action.payload,
          isSubmitting: false,
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/page/reducer.js